import Cookies from 'js-cookie';

/**
 * 获取cookie
 */
export function getCookie(name: string) {
    return Cookies.get(name);
}

export function getQueryString(name: string) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

// 判断ios/安卓
export const browser = {
    versions: (function () {
        let u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        };
    })(),
    language: ((navigator as any).browserLanguage || navigator.language).toLowerCase(),
};

/**
 * 加载外部脚本
 * @param {string} src 脚本路径
 * @param {boolean} async 是否异步加载（默认为 false，与 HTML script 标签的默认行为一致）
 * @returns {Promise<HTMLScriptElement>}
 */
export const loadScript = (src: string, async = false): Promise<HTMLScriptElement> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = async;
        script.onload = () => resolve(script); // script.onload是一次性监听器，加载完成会被移除
        script.onerror = error => reject(new Error(`脚本加载失败: ${src}，错误: ${error}`));

        document.body.appendChild(script);
    });
};
